import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { StyledButton } from "../../../components/Button/button";
import { LoadingBackDrop } from "../../../components/loader";
import { getAllSubcontractor } from "../../../services/subcontractor/get-all";
import { Contractor } from "../../../services/subcontractor/get-all/types";

interface SubcontractorPickProps {
  setSubcontractorId: (subcontractorId: string) => void;
  setFormValid: (formValid: boolean) => void;
}

const SubcontractorPick = ({setSubcontractorId, setFormValid}:SubcontractorPickProps) => {
  const navigate = useNavigate();

  const [subcontractors, setSubcontractors] = useState<Contractor[]>([]);


  const body = {
    paginacja: null,
  };
  const GetAllSubcontractor = useQuery(
    ["AllSubcontractor"],
    () => getAllSubcontractor(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onSuccess(data) {
        setSubcontractors(data.data.payload.wykonawcy);
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      wykonawca_id: "",
    },
    onSubmit: (values) => {
    },
  });

  useEffect(() => {
    if (formik.values.wykonawca_id) {
      setSubcontractorId(formik.values.wykonawca_id);
      setFormValid(true);
    }
  }, [formik.values.wykonawca_id]);

  if (GetAllSubcontractor.isLoading || GetAllSubcontractor.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }
  return ( 
    <SubcontractorPickerWrapper>
      <FormControl fullWidth>
        <InputLabel id="podwykonawcyLabel">Wybierz podwykonawcę</InputLabel>
        <Select
          placeholder="Podwykonawcy"
          labelId="podwykonawcyLabel"
          id="podwykonawcy"
          name="wykonawca_id"
          value={formik.values.wykonawca_id}
          label="Wybierz podwykonawcę"
          onChange={formik.handleChange}
          // disabled={!isEditable}
          style={{ backgroundColor: "white" }}
        >
          {subcontractors.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.nazwa_wykonawcy}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {/* Lub
      <StyledButton
        onClick={() => {
          return navigate(`/operator/subcontractors/add-subcontractor`);
        }}
      >
        Dodaj nowego podwykonawcę
      </StyledButton> */}
    </SubcontractorPickerWrapper>
  );
}

export default SubcontractorPick;

const SubcontractorPickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // width: 45%;
  `